import { NgModule } from '@angular/core';
import { AccountLockButton, AccountMenuSelectionUtils, ImageLoaderUtils, SpinnerUtils } from '@app/utils/utils';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@app/modules/shared.module';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { FormsModule } from '@angular/forms';
import { AngularSvgIconModule } from 'angular-svg-icon';

@NgModule({
  imports: [CommonModule, SharedModule, MatProgressBarModule, FormsModule, AngularSvgIconModule],
  declarations: [SpinnerUtils, AccountLockButton, AccountMenuSelectionUtils, ImageLoaderUtils],
  providers: [],
  exports: [SpinnerUtils, AccountLockButton, AccountMenuSelectionUtils, ImageLoaderUtils],
})
export class UtilsModule {}
